export default __webpack_public_path__ + "c659d5c7875c6b8e0f87810119fe14f0.png";